// extracted by mini-css-extract-plugin
export var bold = "_redotech-redo-return-app-src-order-order-tracking-product-delivery-range-bold";
export var container = "_redotech-redo-return-app-src-order-order-tracking-product-delivery-range-container";
export var deliveryIcon = "_redotech-redo-return-app-src-order-order-tracking-product-delivery-range-delivery-icon";
export var smolText = "_redotech-redo-return-app-src-order-order-tracking-product-delivery-range-smol-text";